import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Axis3d: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M4 4v16h16' }],
    ['path', { d: 'm4 20 7-7' }],
  ],
];

export default Axis3d;
